import { useMemo } from 'react'
import { Input, InputProps } from '@overdose/components'
import { BaseMoney } from 'shared-types/src/commercetools'
import { useFormatPrice } from '~/hooks'

export interface PriceInputProps
  extends Omit<InputProps, 'value' | 'defaultValue' | 'onChange'> {
  defaultValue: string | BaseMoney
  value?: string
  onChange?: (value: string, e: React.ChangeEvent<HTMLInputElement>) => void
}

export const PriceInput = ({
  defaultValue,
  value,
  onChange,
  ...props
}: PriceInputProps) => {
  const { formatPrice, formatPriceSymbol } = useFormatPrice()

  const prefix =
    typeof defaultValue === 'string' ? '' : formatPriceSymbol(defaultValue)
  const initialValue = useMemo(() => {
    const v =
      typeof defaultValue === 'string'
        ? defaultValue
        : formatPrice(defaultValue).slice(prefix.length)

    if (!v) {
      return 0
    }

    return Math.round(Number(v))
  }, [defaultValue, formatPrice, prefix])

  const handleChange = (
    value: string,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const regx = /^[0-9]+$/
    if (regx.test(value)) {
      onChange?.(value, e)
    }
  }

  return (
    <Input
      {...props}
      theme={{ root: '', input: '!outline-0 !border-0' }}
      prefix={`$${prefix}`}
      value={value}
      defaultValue={initialValue}
      onChange={handleChange}
    />
  )
}
